import * as React from "react";

import type {StyleType} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {semanticColor} from "@khanacademy/wonder-blocks-tokens";
import {aiBatteryIconAriaLabel} from "@khan/guide-utils";

import {getIcon} from "./get-icon.ts";

interface Props {
    fraction: number;
    style?: StyleType;
    color?: string;
    remainingQuota?: number | null;
    isHighTraffic?: boolean;
}

const BatteryIcon = (props: Props): React.ReactElement => {
    return (
        <PhosphorIcon
            color={
                props.color || semanticColor.core.foreground.knockout.default
            }
            icon={getIcon(props.fraction)}
            size="medium"
            style={props.style}
            // We add this aria-label for accessibility purposes, even though
            // there's a tooltip.
            aria-label={
                props.remainingQuota != null
                    ? aiBatteryIconAriaLabel(
                          props.remainingQuota,
                          !!props.isHighTraffic,
                      )
                    : undefined
            }
            role="img"
        />
    );
};

export default BatteryIcon;
